// extracted by mini-css-extract-plugin
export var heroWrapperStyle = "sr_hero-module--heroWrapperStyle--Jrvvq";